var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:[_vm.getDisplayedStyles, _vm.getVariant],style:(_vm.styles)},[_vm._v(" "+_vm._s(this.$vnode.componentOptions.children[0].text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }